let files = [
  "asana.png",
  "aws.png",
  "bootstrap.png",
  "c-plus-plus.png",
  "c-program.png",
  "codepen.png",
  "css.png",
  "electron.png",
  "express.png",
  "firebase.png",
  "git.png",
  "github.png",
  "gitlab.png",
  "google-map.png",
  "heroku.png",
  "html.png",
  "ionic.png",
  "java.png",
  "javascript.png",
  "jsfiddle.png",
  "json.png",
  "markdown.png",
  "microsoft-teams.png",
  "mongodb.png",
  "nextjs.png",
  "nodejs.png",
  "npm.png",
  "postman.png",
  "pycharm.png",
  "r.png",
  "react.png",
  "redux.png",
  "sass.png",
  "slack.png",
  "socketio.png",
  "stackoverflow.png",
  "svelte.png",
  "tailwind.png",
  "typescript.png",
  "visual-studio-code.png",
  "zeplin.png",
];

let tools = ["aws", "heroku", "postman", "zeplin"];

let platforms = [
  "codepen",
  "github",
  "gitlab",
  "jsfiddle",
  "pycharm",
  "stackoverflow",
  "visual-studio-code",
];

let management = ["asana", "microsoft-teams", "slack"];

let tech = [
  "bootstrap",
  "c-plus-plus",
  "c-program",
  "css",
  "electron",
  "express",
  "firebase",
  "git",
  "google-map",
  "html",
  "ionic",
  "java",
  "javascript",
  "json",
  "markdown",
  "mongodb",
  "nextjs",
  "nodejs",
  "npm",
  "r",
  "react",
  "redux",
  "sass",
  "socketio",
  "svelte",
  "tailwind",
  "typescript",
];

let res = files.map((file) => {
  var obj = {};
  obj["img"] = `/assets/images/icons/${file}`;
  obj["name"] = file.split(".")[0].replace(/-/g, " ");
  return obj;
});

tech = tech.map((val) => {
  return {
    img: `/assets/images/icons/${val}.png`,
    name: val.replace(/-/g, " "),
  };
});

management = management.map((val) => {
  return {
    img: `/assets/images/icons/${val}.png`,
    name: val.replace(/-/g, " "),
  };
});

tools = tools.map((val) => {
  return {
    img: `/assets/images/icons/${val}.png`,
    name: val.replace(/-/g, " "),
  };
});

platforms = platforms.map((val) => {
  return {
    img: `/assets/images/icons/${val}.png`,
    name: val.replace(/-/g, " "),
  };
});

let skills = {
  platforms,
  management,
  tech,
  tools,
};

module.exports = {
  res,
  skills,
};
